const getCatalogo54 = state => state.catalogo54;
const getCatalogo59 = state => state.catalogo59;
const getCatalogo06 = state => state.catalogo06;
const getCatalogo07 = state => state.catalogo07;
const getCatalogo09 = state => state.catalogo09;
const getCatalogo10 = state => state.catalogo10;
const getCatalogo17 = state => state.catalogo17;
const getCatalogo18 = state => state.catalogo18;
const getCatalogo20 = state => state.catalogo20;
const getCatalogo63 = state => state.catalogo63;
const getCatalogo64 = state => state.catalogo64;
const getUbigeo = state => state.ubigeo;
const getUbigeoTotal = state => state.ubigeoTotal;
const getCuentas = state => state.cuentas ? state.cuentas : [];
const getParametros = state => state.parametros;
const getOficinas = state => state.oficinas;
const getOfs = state => state.ofs;
const getClientes = state => state.clientes;
const getProductos = state => state.productos;

export default {
  getCuentas,
  getCatalogo64,
  getCatalogo63,
  getCatalogo54,
  getCatalogo59,
  getCatalogo06,
  getCatalogo07,
  getCatalogo09,
  getCatalogo10,
  getCatalogo17,
  getCatalogo18,
  getCatalogo20,
  getUbigeo,
  getUbigeoTotal,
  getParametros,
  getOficinas,
  getOfs,
  getClientes,
  getProductos
};



// WEBPACK FOOTER //
// ./src/store/modules/catalogos/getters.js